import {
  CPILibraryItem,
  ExclusionFieldsResponse,
  ExclusionRule,
  ExclusionRuleConditionInput,
  ExclusionRuleMatchType,
  IntegrationInstance
} from 'models'
import { ModalProps } from 'store/modals/modalSlice'

export type CreateRuleModalProps = NonNullable<ModalProps['createExclusionRuleProps']>
export type CreateRuleMode = CreateRuleModalProps['mode']

interface BuildArgs {
  cpi: Pick<CPILibraryItem, 'name' | 'display_name'> | null | undefined
  exclusionFields: ExclusionFieldsResponse | null
  unitsLabel: string | undefined
  mode: CreateRuleMode
  initialConditions?: ExclusionRuleConditionInput[]
  initialMatchType?: ExclusionRuleMatchType
  rule?: ExclusionRule
  dataSourceOptions?: IntegrationInstance[]
  onSuccess?: () => void
}

/** Shared by every create and edit entry point so the modal props are derived one way. Null when there is nothing to build on. */
export const buildCreateRuleModalProps = ({
  cpi,
  exclusionFields,
  unitsLabel,
  mode,
  initialConditions = [],
  initialMatchType,
  rule,
  dataSourceOptions = [],
  onSuccess
}: BuildArgs): CreateRuleModalProps | null => {
  if (!cpi || !exclusionFields) return null
  return {
    cpiSlug: cpi.name,
    cpiDisplayId: cpi.display_name?.toUpperCase().replace(/\s+/g, '-') || cpi.name.toUpperCase(),
    exclusionFields: exclusionFields.fields,
    recordIdentifier: exclusionFields.record_identifier,
    unitsLabel: unitsLabel || 'records',
    mode,
    initialConditions,
    ...(initialMatchType && { initialMatchType }),
    ...(rule && { rule }),
    instanceDisplayNames: Object.fromEntries(
      dataSourceOptions.filter((o) => o.instance_name && o.name).map((o) => [o.instance_name as string, o.name])
    ),
    ...(onSuccess && { onSuccess })
  }
}
